<template>
	<div class="galery">
		<div class="galery__close-button" @click="closeGalery"><img src="@/assets/navigation/cross.svg"/></div>
		<div class="galery-wrapper">
			<div v-if="project" class="project-details">
				<h1>{{ project.title }}</h1>
				<p>{{ project.description }}</p>
			</div>
			<div v-if="isImage(galeryFile)" class="galery__img">
				<img :src="require(`@/assets/projects/${galeryFile}`)" />
			</div>
			<div v-else class="galery-video">
				<video class="video" autoplay muted loop :src="require(`@/assets/projects/${galeryFile}`)"></video>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	methods: {
		closeGalery () {
			this.$store.dispatch('closeGalery')
			this.$store.dispatch('startAutoplay')
		},
		isImage (file) {
			const fileExtension = file.split('.').pop()
			return !!(fileExtension === 'jpg' || fileExtension === 'png')
		}
	},
	computed: {
		...mapGetters(['projects', 'galeryFile']),
		project () {
			return this.projects.find(project => project.heroImage === this.galeryFile)
		}
	}
}
</script>

<style lang="scss" scoped>
.galery {
	position: absolute;
	top: 0;
	left: 0;
	background: black;
	width: 100vw;
	min-height: 100vh;
	z-index: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	color: white;
	padding: 6.5rem 3rem 3rem;
	overflow: auto;

	&__close-button {
		position: fixed;
		top: 3.5rem;
		right: 3rem;
		width: 4rem;
		height: 3rem;
		cursor: pointer;
		z-index: 1;

		img {
			width: 100%;
		}
	}

	&-wrapper {
		max-width: 1250px;
	}

	img, video {
		width: 100%;
		display: block;
	}
}

.project {
	&-details {
		h1 {
			font-size: 4rem;
			line-height: 4rem;
		}
		p {
			margin-top: 2.5rem;
		}
		margin-bottom: 3rem;
	}
}
</style>
